import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const StatusOverlay = React.memo(function StatusOverlay({ message, visible }) {
    if (!message)
        return null;
    return (_jsx("div", { className: `hekate-player-status-overlay ${visible ? 'hekate-player-status-overlay--visible' : ''}`, "aria-live": "polite", "aria-atomic": "true", children: message }));
});
